<template>
    <div class="result-item">
        <Carousel :images="item.preview_urls || [item.image]" />

        <div class="result-info">
            <div class="id">{{ item.id }}</div>
            <div v-if="item.score" class="score">
                Сходство: {{ (item.score * 100).toFixed(1) }}%
            </div>
            <div class="created_at">
                {{ formatDate(item.created_at || item.meta?.created_at) }}
            </div>
            <div class="actions">
                <a :href="item.crm_link || item.meta?.crm_link || '#'" target="_blank" class="btn">
                    Открыть в CRM
                </a>
                <a
                    :href="item.constructor_link || item.meta?.constructor_link || '#'"
                    target="_blank"
                    class="btn secondary"
                >
                    Открыть в конструкторе
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import { defineComponent } from 'vue'
    import Carousel from './Carousel.vue'

    export default defineComponent({
        components: { Carousel },
        props: {
            item: {
                type: Object,
                required: true
            }
        },
        methods: {
            formatDate(dateStr) {
                if (!dateStr) return 'Дата неизвестна'

                const date = new Date(dateStr)
                return date.toLocaleDateString('ru-RU', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                })
            }
        }
    })
</script>
